import { ISubscriberFn, WidgetType } from '../types';

export const COMPETITION_SUBSCRIBE_TYPE = 'competition';
export const BETTING_MARKET_VALUE_SUBSCRIBE_TYPE = 'bettingMarketValue';
export const BETTING_LOGO_SUBSCRIBE_TYPE = 'bettingLogo';
export const TEAM_SUBSCRIBE_TYPE = 'team';
export const PLAYER_SUBSCRIBE_TYPE = 'player';
export const COACH_SUBSCRIBE_TYPE = 'coach';
export const MATCH_SCORE_SUBSCRIBE_TYPE = 'matchScore';
export const PREDICTION_SUCCESS_SUBSCRIBE_TYPE = 'onPredictionSuccess';
export const PREDICTION_ERROR_SUBSCRIBE_TYPE = 'onPredictionError';
export const EVENT_SUBSCRIBE_TYPE = 'event';
export const USER_INTERACTION_SUBSCRIBE_TYPE = 'onUserInteraction';
export const DROPDOWN_SELECTION_SUBSCRIBE_TYPE = 'dropdownSelection';
export const TAB_SELECTION_SUBSCRIBE_TYPE = 'tabSelection';
export const SHOW_MORE_SUBSCRIBE_TYPE = 'showMore';
export const SHOW_PREVIOUS_SUBSCRIBE_TYPE = 'showPrevious';

export interface IGeneralSubscriberInfo {
  subscribers?: { [key: string]: ISubscriberFn[] };
  dataWidgetSport?: string;
  dataWidgetType?: WidgetType;
  dataWidgetId?: string;
  dataWidgetCuid?: string;
}
